/**
 * Composant ResponsesDialog pour la page Satisfaction
 * Boîte de dialogue affichant les réponses détaillées d'un questionnaire
 */

import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { renderStars } from './GlobalRating';

export const ResponsesDialog = ({
  open,
  onOpenChange,
  questionnaire,
  types
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="responses-dialog">
        <DialogHeader>
          <DialogTitle>Réponses au questionnaire</DialogTitle>
          <DialogDescription>
            {questionnaire?.destinataire_nom} - {types[questionnaire?.type]?.label}
          </DialogDescription>
        </DialogHeader>
        
        {questionnaire?.reponses && (
          <div className="space-y-4 max-h-[60vh] overflow-y-auto">
            {Object.entries(questionnaire.reponses).map(([questionId, reponse]) => (
              <div key={questionId} className="p-4 bg-slate-50 rounded-lg">
                <p className="font-medium text-slate-700 mb-2">{questionId}</p>
                {typeof reponse === 'number' ? (
                  <div className="flex items-center gap-2">
                    {renderStars(reponse)}
                  </div>
                ) : (
                  <p className="text-slate-600">{reponse}</p>
                )}
              </div>
            ))}
          </div>
        )}
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Fermer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ResponsesDialog;
